import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TranslateLoader } from '@ngx-translate/core';

export class AppTranslateHttpLoader implements TranslateLoader {
  constructor(private http: HttpClient, public prefix: string = './assets/i18n/', public suffix: string = '.json') {}

  getTranslation(lang: string): Observable<object> {
    return this.http.get(`${this.prefix}${lang}${this.suffix}`, {
      headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
      },
    });
  }
}
